import {TextField } from '@mui/material'
import styles from './ConsumerInfoView.module.scss'
import { useState } from 'react';
import Modal from '../../../../../../common/components/molecule/Modal/Modal';
import Button from '../../../../../../common/components/atom/ButtonV2/Button';
import counterIcon from './assets/counter.svg'
export interface ConsumerInfoViewProps {
  devEuiValue?: string,
  setDevEuiValue ?: (id: string) => void,
  onSubmit?: () => void,
  isLoading?: boolean,
  currentDevEui?: string
}
export default function ConsumerInfoView({devEuiValue, setDevEuiValue, onSubmit, isLoading,   currentDevEui}: ConsumerInfoViewProps) {

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  }
  const handleOpen = () => {
    setOpen(true);
  }
  return (
    <>
    <div className={ styles['consumer-info']}>
      <Button variant="contained" color="white" style={{height:40}} onClick={handleOpen}
        iconRightType='arrow-down'
  
        LeftIconRender={() => <img className={styles['icon-counter']} src={counterIcon} alt="counter" />}
      >{currentDevEui || 'Compteur'}</Button>
    </div>
    <Modal isOpen={open} handleClose={() => setOpen(false)}>
      <div className={ styles['modal-content']}>  
        {setDevEuiValue&& (
              <TextField
                id="dev_eui"
                label="Compteur"
                placeholder='xxxxxx'
                type="Text"
                defaultValue=""
                InputLabelProps={{ shrink: true }}
                value={devEuiValue}
                onChange={(e) => {
                  setDevEuiValue(e.target.value);
                }}
              />
            )}
            <div className={styles['btn-container']}>

            
            <Button
                color="primary"
                variant='outlined'
                onClick={(e) => {
                  e.preventDefault();
        
                  handleClose && handleClose();
                }}
                type="submit"
           
              >
                Annuler
              </Button>
              {onSubmit && (
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  onSubmit();
                  handleClose && handleClose();
                }}
                type="submit"
             
              >
                Valider
              </Button>

              
            )}
              </div>
            </div>
    </Modal>
    </>
  )
}
